import { memo } from 'react';
import { cn, Discount } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Link from '@Navigation/Link';
import styles from './CurrentDiscountsCard.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { OfferCategoryData } from '@Pages/PagePromotionsDiscounts/typings';

export interface CurrentDiscountsCardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  category: OfferCategoryData;
}

const CurrentDiscountsCard: FC<CurrentDiscountsCardProps> = (props) => {
  const { className, category } = props;
  const { t } = useTranslation();
  const discount = category.discount ? `${t('ui.range.to')} −${category.discount}` : null;

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Link className={styles.name} to={category.link}>
            {category.title}
          </Link>
          {category.count > 0 && <div className={styles.count}>{category.count}</div>}
        </div>
        <div className={styles.footer}>
          {!!discount && (
            <Discount className={styles.discount} value={discount} view='green' customText />
          )}
        </div>
      </div>

      <img className={styles.image} src={category.image} alt='' />
      <Link className={styles.link} to={category.link} />
    </div>
  );
};

export default memo(CurrentDiscountsCard);
